<template>
  <el-dialog title="取消订单" :visible.sync="dialogVisible" width="600px" center destroy-on-close	>
    <el-form :model="editForm">
      <el-form-item label="总服务天数" :label-width="formLabelWidth">
        {{ cancelOrderInfo.service_days_num }}天
      </el-form-item>
      <el-form-item label="已服务天数" :label-width="formLabelWidth">
        {{ cancelOrderInfo.nurse_records_num }}天
      </el-form-item>
      <el-form-item label="应退款金额" :label-width="formLabelWidth">
        ¥{{ cancelOrderInfo.refund_fee }}
      </el-form-item>
      <el-form-item label="实退款金额" :label-width="formLabelWidth">
        <el-input v-model="editForm.actual_refund_fee" autocomplete="off" placeholder="请输入实退款金额"></el-input>
      </el-form-item>
      <el-form-item v-if="status === OrderAllStatus[5].val" :label-width="formLabelWidth">
        <el-radio-group v-model="editForm.action">
          <el-radio :label="1">通过申请</el-radio>
          <el-radio :label="2">不通过申请</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSubmit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { cancelOrderById, auditOrderCancelById } from '../../../api'
import { OrderAllStatus } from '../../../enum/orders'

export default {
  name: 'CancelOrder',
  data() {
    return {
      OrderAllStatus,
      dialogVisible: false,
      formLabelWidth: '153px',
      status: 1,
      editForm: {
        nurse_id: '',
        action: '',
        actual_refund_fee: ''
      },
      cancelOrderInfo: {}
    }
  },
  methods: {
    async handleOpen(val) {
      const { orderInfo: { id: order_id, order_status }, cancelOrderInfo } = val
      this.cancelOrderInfo = cancelOrderInfo
      this.status = order_status
      this.editForm = {
        order_id,
        action: '',
        actual_refund_fee: ''
      }
      if (order_status === OrderAllStatus[5].val) {
        this.editForm.action = ''
      }
      this.dialogVisible = true
    },
    handleSubmit() {
      const { status: order_status } = this
      const { order_id, actual_refund_fee, action } = this.editForm
      const { actual_refund_fee: realRefundMaxPrice } = this.cancelOrderInfo
      let c = cancelOrderById

      if (!actual_refund_fee) return this.$message({ message: '请输入实退款金额！', type: 'warning' })
      if (Number(actual_refund_fee) > Number(realRefundMaxPrice)) return this.$message({ message: '实退款金额不得大于应退金额！', type: 'warning' })

      const params = {
        order_id, actual_refund_fee
      }
      if (order_status === OrderAllStatus[5].val) {
        console.log(action)
        if (action === '') return this.$message({ message: '请选择是否同意！', type: 'warning' })
        params.action = action
        c = auditOrderCancelById
      }
      c(params).then(res => {
        if (res.status) {
          this.$message.success(res.msg)
          this.handleClose()
          this.$emit('update')
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    handleClose() {
      this.dialogVisible = false
    },
    inputFn(_Text) {
      this.editForm[_Text] = (this.editForm[_Text]).replace(/[^\d]/g, '').replace(/^0{1,}/g, '')
    }
  }
}
</script>

<style scoped>

</style>
